var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Header"),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { id: "main" } },
        [
          _c("Vitrine"),
          _vm._v(" "),
          _c("AboutSection"),
          _vm._v(" "),
          _c("StoresSection", { attrs: { stores: _vm.stores } }),
          _vm._v(" "),
          _c("ProjectsSection", { attrs: { projects: _vm.projects } }),
          _vm._v(" "),
          _c("NewsletterSection"),
          _vm._v(" "),
          _c("HowWorksSection"),
          _vm._v(" "),
          _c("TestimonySection"),
          _vm._v(" "),
          _c("JoinSection"),
          _vm._v(" "),
          _vm.categories
            ? _c("MillestonesSection", {
                attrs: { categories: _vm.categories }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("PartnersSection"),
          _vm._v(" "),
          _c("ContactSection"),
          _vm._v(" "),
          _c("transition", { attrs: { name: "fade" } }, [
            _vm.showScrollButton
              ? _c("div", { attrs: { id: "scrollToTop" } }, [
                  _c(
                    "a",
                    {
                      attrs: { href: "" },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          $event.preventDefault()
                          return _vm.scrollToTop()
                        }
                      }
                    },
                    [
                      _c("font-awesome-icon", {
                        attrs: {
                          icon: ["fas", "chevron-circle-up"],
                          size: "lg"
                        }
                      })
                    ],
                    1
                  )
                ])
              : _vm._e()
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("Footer"),
      _vm._v(" "),
      _vm.loading ? _c("Loading") : _vm._e(),
      _vm._v(" "),
      _vm.showPrivacyPolicyModal
        ? _c("div", { attrs: { id: "privacyPolicy" } }, [
            _c("div", { staticClass: "background" }),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _c(
              "button",
              {
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    $event.preventDefault()
                    _vm.showPrivacyPolicyModal = false
                  }
                }
              },
              [_vm._v("OK")]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.showAddToHomescreen
        ? _c(
            "div",
            {
              attrs: { id: "addToHomescreen" },
              on: {
                click: function($event) {
                  _vm.showAddToHomescreen = false
                }
              }
            },
            [
              _c("span", [
                _vm._v("Adicione um atalho na sua tela inicial!"),
                _c("br"),
                _vm._v(" Clique no ícone "),
                _c("img", { attrs: { src: _vm.shareIcon } }),
                _vm._v(" e em seguida "),
                _c("b", [_vm._v("Tela de Início")])
              ])
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _vm._v("Utilizamos tecnologias essenciais de acordo com a nossa "),
      _c("a", { attrs: { href: "/privacy-policy" } }, [
        _vm._v("Política de Privacidade")
      ]),
      _vm._v(" e, ao continuar navegando, você concorda com estas condições.")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8dc7cce2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8dc7cce2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = null
// module chunks = 